import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MaterialModule } from "@app/material.module";
import { TranslateModule } from "@ngx-translate/core";
import { WorkspaceChangeConfirmDialogComponent } from "./workspace-change-confirm-dialog.component";

@NgModule({
	declarations: [WorkspaceChangeConfirmDialogComponent],
	imports: [CommonModule, MaterialModule, TranslateModule],
	exports: [WorkspaceChangeConfirmDialogComponent],
})
export class WorkspaceChangeConfirmDialogModule {}
